import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const STORAGE_KEY = 'cookie-consent-v1';

type ConsentChoice = 'analytics' | 'necessary';

function applyConsent(choice: ConsentChoice) {
  window.localStorage.setItem(STORAGE_KEY, choice);
  window.dispatchEvent(new CustomEvent('analyticsConsentChange', { detail: { statistics: choice === 'analytics' } }));
}

const CookieConsent = () => {
  const { language } = useLanguage();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'analytics' || saved === 'necessary') applyConsent(saved);
    else setOpen(true);

    const openSettings = () => setOpen(true);
    window.addEventListener('openCookieSettings', openSettings);
    return () => window.removeEventListener('openCookieSettings', openSettings);
  }, []);

  const choose = (choice: ConsentChoice) => {
    applyConsent(choice);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-x-4 bottom-4 z-[100] mx-auto max-w-3xl rounded-2xl border border-gray-200 bg-white p-5 shadow-2xl sm:p-6" role="dialog" aria-modal="true" aria-labelledby="cookie-consent-title">
      <h2 id="cookie-consent-title" className="font-serif text-xl font-semibold text-navy">
        {language === 'bg' ? 'Настройки за бисквитки' : 'Cookie settings'}
      </h2>
      <p className="mt-2 text-sm leading-6 text-slate">
        {language === 'bg'
          ? 'Използваме необходими технологии за работата на сайта. С Ваше съгласие използваме и Google Analytics, за да разбираме как се използва сайтът.'
          : 'We use necessary technologies to operate the website. With your consent, we also use Google Analytics to understand how the website is used.'}
      </p>
      <a href="/privacy-policy" className="mt-2 inline-block text-sm font-semibold text-gold hover:underline">
        {language === 'bg' ? 'Политика за поверителност' : 'Privacy Policy'}
      </a>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button type="button" onClick={() => choose('analytics')} className="rounded-lg bg-navy px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-accent">
          {language === 'bg' ? 'Приемам всички' : 'Accept all'}
        </button>
        <button type="button" onClick={() => choose('necessary')} className="rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-semibold text-navy transition-colors hover:bg-gray-50">
          {language === 'bg' ? 'Само необходими' : 'Necessary only'}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
